<template>
    <header class="main-header">

        <a href="/" class="logo">
            <span class="logo-mini"><img class="logo-svg" src="../assets/logo.svg"></span>
            <span class="logo-lg"><img class="logo-svg" src="../assets/logo.svg"></span>
        </a>

        <nav class="navbar navbar-static-top" role="navigation">
            <a href="#" class="sidebar-toggle" data-toggle="push-menu" role="button">
                <span class="sr-only">Навигация</span>
            </a>
        </nav>
    </header>
</template>

<script>
    export default {
        name: "Navbar"
    }
</script>

<style scoped>
    @media (max-width: 767px) {
        .navbar-static-top {
            height: 1px!important;
            min-height: 1px!important;
        }
    }
</style>
